export default __webpack_public_path__ + "static/media/Ubuntu-Bold.7b253bf0.woff2";